import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import TitleBtn from '../components/TitleBtn';
import TitleImage from '../components/TitleImage';
import aboutPhoto from '../assets/images/aboutphotofinal.jpg';
import Layoutsvg from '../components/Layoutsvg';
import Menu from '../components/Menu';

import { TitleWrapper, TitleDesc } from '../components/StyledComponents/StyledComp';

//importing animations
import { MainWrapperVariants, MainNameVariants, MainLine1Variants, MainLine2Variants, MainRoleVariants } from '../animations/MainPageAnims';

function About() {


    const navigate = useNavigate();
    var scrolled = false;
    function handleScroll(e) {

        if (!scrolled) {
            scrolled = true;
            // console.log("scrolled with about");
            const y = e.wheelDeltaY;
            if (y < 0) {
                navigate("/projects");
            } else {
                navigate("/");
            }
            // setTimeout(()=> scrolled=false , 2000);
        }
    }

    useEffect(() => {
        scrolled = false;
        setTimeout(() => {

            //FOR MOBILE
            let touchstartX = 0;
            let touchendX = 0;
            let touchstartY = 0;
            let touchendY = 0;
            function handleGesture(e) {
                if (!scrolled) {

                    var diffX = touchstartX - touchendX;
                    var diffY = touchstartY - touchendY;

                    if (Math.abs(diffX) < Math.abs(diffY)){
                        if (diffY > 0) {
                            // swiped up
                            // console.log("swiped up");
                            navigate('/projects');
                          } else {
                            // swiped down
                            // console.log("swiped down");
                            navigate('/');
                          }  
                    }
                }
            }

            const wrapper = document.querySelector(".about-wrapper");


            if(wrapper){
                wrapper.addEventListener('touchstart', e => {
                    touchstartX = e.touches[0].clientX;
                    touchstartY = e.touches[0].clientY;
                });
                wrapper.addEventListener('touchmove', e => {
                    if (touchstartX === null ||  touchstartY === null) {
                        return;
                    }

                    touchendX = e.touches[0].clientX;
                    touchendY = e.touches[0].clientY;
                    handleGesture();
                });
                wrapper.addEventListener("wheel", handleScroll);
            }
        }, 1500);


    }, []);

    const gotoDetail = () => {
        // console.log("goto");
        scrolled = true;
        navigate('/aboutdetail');
    }


    return (
        <TitleWrapper className='about-wrapper' >
            <Layoutsvg />
            <Menu />
            <motion.div
            >
                <TitleDesc>
                    <motion.p
                        variants={MainNameVariants}
                        initial='initial'
                        animate='animate'
                        className="title-text">About Me</motion.p>
                    <motion.div
                        variants={MainLine1Variants}
                        initial='initial'
                        animate='animate'
                        className="redline1"></motion.div>
                    <motion.div
                        variants={MainLine2Variants}
                        initial='initial'
                        animate='animate'
                        className="redline2"></motion.div>
                    <motion.div
                        variants={MainRoleVariants}
                        initial='initial'
                        animate='animate'
                        className="role">
                        <p className='title-lead' >Who I am</p>
                        <p className='title-lead' >(Beyond job titles)</p>
                    </motion.div>
                    <TitleBtn content="Let's go" link="/about/detail" onClick={gotoDetail} />
                </TitleDesc>
                <TitleImage pageNumber="01" photoSource={aboutPhoto} />
            </motion.div>
        </TitleWrapper>
    );
}


export default About;